import hero1280 from '../../assets/images/responsive/hero-sunrise-1280.webp';
import hero1920 from '../../assets/images/responsive/hero-sunrise-1920.webp';
import hero2560 from '../../assets/images/responsive/hero-sunrise-2560.webp';
import hero3840 from '../../assets/images/responsive/hero-sunrise-3840.webp';
import heroMobile960 from '../../assets/images/responsive/hero-sunrise-mobile-960.webp';
import heroMobile1440 from '../../assets/images/responsive/hero-sunrise-mobile-1440.webp';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import { Button } from '../button/Button';
import styles from './Hero.module.scss';

const facts = [
  'Все коммуникации подведены',
  'Широкие дороги',
  'Участки 10–20 соток',
  'Озеро внутри посёлка',
];

export function Hero() {
  return (
    <section className={styles.hero} id="top" aria-labelledby="hero-title">
      <picture className={styles.backdrop} aria-hidden="true">
        <source
          media="(max-width: 767px)"
          srcSet={`${heroMobile960} 960w, ${heroMobile1440} 1440w`}
          sizes="100vw"
        />
        <img
          src={hero1920}
          srcSet={`${hero1280} 1280w, ${hero1920} 1920w, ${hero2560} 2560w, ${hero3840} 3840w`}
          sizes="100vw"
          width="3840"
          height="2160"
          alt=""
          fetchPriority="high"
          decoding="async"
        />
      </picture>
      <div className={styles.overlay} aria-hidden="true" />

      <div className={styles.content}>
        <div className={styles.offer}>
          <p className={styles.eyebrow}>Коттеджный посёлок рядом с Петергофом</p>
          <h1 className={styles.title} id="hero-title">
            <span>Свой дом у Петергофа —</span> <span>в трёх километрах от КАД</span>
          </h1>
          <p className={styles.lead}>
            Просторные участки ИЖС 10–20 соток со всеми центральными коммуникациями, широкими
            дорогами и собственным озером. Школа, детский сад, магазины и другие необходимые объекты
            — в пешей доступности.
          </p>

          <div className={styles.actions}>
            <Button href="tel:+79956003109">Позвонить</Button>
            <Button
              href="#genplan"
              variant="secondary"
              onClick={() => trackAnalyticsGoal(analyticsGoals.heroGenplanClick)}
            >
              Выбрать участок
            </Button>
          </div>
        </div>

        <div className={styles.facts} aria-label="Ключевые преимущества">
          {facts.map((fact, index) => (
            <div key={fact} className={styles.fact}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <strong>{fact}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
